"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOptions = exports.deviceOptions = void 0;
exports.deviceOptions = [
    'mobileXs',
    'mobileSm',
    'mobileLg',
    'tabletSm',
    'tabletMd',
    'tabletLg',
    'laptopSm',
    'laptopLg',
    'desktopLg',
];
exports.filterOptions = ['only', 'portrait', 'landscape', 'min', 'max', 'minIgnoreSidebar'];
